'use client';

import React from 'react';

interface KioskStatusBarProps {
  isOnline: boolean;
  isAuthorized: boolean;
  secondsRemaining: number;
}

export default function KioskStatusBar({
  isOnline,
  isAuthorized,
  secondsRemaining,
}: KioskStatusBarProps) {
  return (
    <footer className="flex items-center justify-between px-10 py-4 border-t kiosk-border">
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2 text-sm kiosk-muted">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
            <circle cx="12" cy="10" r="3"/>
          </svg>
          TEI Main School — Common Area
        </div>
        <div className="flex items-center gap-2 text-sm kiosk-muted">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          Kiosk ID: TEI-K001
        </div>
      </div>

      <div className="flex items-center gap-3 text-sm kiosk-muted">
        {!isOnline && (
          <span className="flex items-center gap-1.5 text-kiosk-red font-medium">
            <span className="w-1.5 h-1.5 rounded-full bg-red-400" />
            Reconnecting...
          </span>
        )}
        {!isAuthorized && (
          <span className="flex items-center gap-1.5 text-kiosk-amber font-medium">
            <span className="w-1.5 h-1.5 rounded-full bg-amber-400" />
            Authorization required — contact admin
          </span>
        )}
        <span className="tabular-nums">
          Next refresh: {String(secondsRemaining).padStart(2, '0')}s
        </span>
      </div>

      <div className="text-sm kiosk-muted">
        clock.theenglishisland.net
      </div>
    </footer>
  );
}